/**
 * One colour per shift (component), by its place in the center's list, so the
 * Shift definitions cards and the pattern calendar agree on what DAY or N12
 * looks like.
 */
export const SHIFT_TONES = [
  { cell: 'bg-sky-500 text-white border-sky-500', chip: 'bg-sky-500', bar: 'bg-sky-400' },
  { cell: 'bg-indigo-500 text-white border-indigo-500', chip: 'bg-indigo-500', bar: 'bg-indigo-400' },
  { cell: 'bg-emerald-500 text-white border-emerald-500', chip: 'bg-emerald-500', bar: 'bg-emerald-400' },
  { cell: 'bg-amber-500 text-white border-amber-500', chip: 'bg-amber-500', bar: 'bg-amber-400' },
  { cell: 'bg-rose-500 text-white border-rose-500', chip: 'bg-rose-500', bar: 'bg-rose-400' },
  { cell: 'bg-violet-500 text-white border-violet-500', chip: 'bg-violet-500', bar: 'bg-violet-400' },
  { cell: 'bg-teal-500 text-white border-teal-500', chip: 'bg-teal-500', bar: 'bg-teal-400' },
  { cell: 'bg-slate-600 text-white border-slate-600', chip: 'bg-slate-600', bar: 'bg-slate-500' },
] as const

export type ShiftTone = (typeof SHIFT_TONES)[number]

/** The tone of a shift given the center's whole list, in its listed order. */
export function shiftTone(ids: readonly string[], id: string): ShiftTone {
  return SHIFT_TONES[Math.max(0, ids.indexOf(id)) % SHIFT_TONES.length]
}
